import React, { useEffect, useState } from "react";
import InputAHSF from "../../../Components/InputAHSF";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import {
  GetOneInformationAboutTheScientificFoundation,
  setInfoScientificFoundation,
} from "../../../Redux/Reducers/Submitter/InformationAboutScientificInstitution";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { decryptToken } from "../../../Services/Encryption/EncryptionParams";
import {
  GetAllSU_ST_MRI_AcademicRank,
  GetAllSU_ST_MRI_FoundationName,
  GetAllSU_ST_MRI_Sector,
} from "../../../Redux/Reducers/Submitter/MainResearcherInformation/DropDown";
import TextAreaAHSF from "../../../Components/TextAreaAHSF";

const InformationAboutScientificInstitution = (props) => {
  const AppGuid = useParams();
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      FetchDataJson: state.FetchDataJson,
      InfoScientificFoundation:
        state.InformationAboutScientificInstitution.InfoScientificFoundation,
      loadingInfoScientificFoundation:
        state.InformationAboutScientificInstitution
          .loadingInfoScientificFoundation,
      DropDownSU_ST_MRI_Sector: state.DropDown.DropDownSU_ST_MRI_Sector,
      DropDownSU_ST_MRI_AcademicRank:
        state.DropDown.DropDownSU_ST_MRI_AcademicRank,
      DropDownSU_ST_MRI_FoundationName:
        state.DropDown.DropDownSU_ST_MRI_FoundationName,
      ValidateMainResearcherPageList:
        state.MainResearcherInformation.ValidateMainResearcherPageList,
        MainResearcherInformation:
        state.MainResearcherInformation.MainResearcherInformain,
    };
  });
  console.log(state.MainResearcherInformation, "ssscxcx");
  const [mainReserchInfo, setMainReserchInfo] = useState();
  const getdata = async () => {
    const data = await dispatch(
      GetOneInformationAboutTheScientificFoundation({
        applicationInformationId:
          localStorage.getItem("ApplicationInformationId") ||
          props.applicationGuid,
      })
    );
    if (data.payload) {
      setMainReserchInfo({ ...data.payload });
    }
  };
  useEffect(() => {
    getdata();
    dispatch(GetAllSU_ST_MRI_Sector());
    dispatch(GetAllSU_ST_MRI_AcademicRank());
  }, []);
  useEffect(() => {
    dispatch(setInfoScientificFoundation({ ...mainReserchInfo }));
  }, [mainReserchInfo]);

  useEffect(() => {
    dispatch(GetAllSU_ST_MRI_FoundationName(mainReserchInfo?.sectorId));
   
  }, [mainReserchInfo?.sectorId]);
  console.log(state.InfoScientificFoundation, "InfoScientificFoundation");

  return !state.loadingInfoScientificFoundation && mainReserchInfo ? (
    <>
      <div className="form-grid">
        <AllDropDownsAHSF
          fieldsName="Sector"
          show={true}
          yesNo={true}
          disabled={props.shouldDisableFields}
          dropdownType="normal"
          arrayOoptionList={state.DropDownSU_ST_MRI_Sector}
          KeyText={"sectorName"}
          KeyValue={"sectorId"}
          value={mainReserchInfo?.sectorId}
          onChange={(e) => {
            setMainReserchInfo({
              ...mainReserchInfo,
              sectorId: parseInt(e.target.value),
              foundationNameId: null,
              otherFoundationName: null, // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ValidateMainResearcherPageList
              ? state.ValidateMainResearcherPageList.includes("Sector")
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        {state.InfoScientificFoundation?.sectorId == 4 ||state.MainResearcherInformation?.sU_NT_MRI_CountryOfResidenceId==2? (
          //   <TextAreaAHSF
          //     fieldsName="otherSector"
          //     show={true}
          //     disabled={props.shouldDisableFields}
          //     defaultValue={mainReserchInfo?.otherSector}
          //     onChange={(e) => {
          //       setMainReserchInfo({
          //         ...mainReserchInfo,
          //         otherSector: e.target.value, // التحديث هنا
          //       });
          //     }}
          //     showValidationMessage={
          //       state.ValidateMainResearcherPageList
          //         ? state.ValidateMainResearcherPageList.includes("otherSector")
          //         : false
          //     }
          //     validationMessage="يرجى تعبئة هذا الحقل"
          //   />
          // ) : (
          //   ""
          // )}
          <TextAreaAHSF
            fieldsName="NameOfFoundation"
            show={true}
            disabled={props.shouldDisableFields}
            defaultValue={mainReserchInfo?.otherFoundationName}
            onChange={(e) => {
              setMainReserchInfo({
                ...mainReserchInfo,
                otherFoundationName: e.target.value, // التحديث هنا
              });
            }}
            showValidationMessage={
              state.ValidateMainResearcherPageList
                ? state.ValidateMainResearcherPageList.includes(
                    "NameOfFoundation"
                  )
                : false
            }
            validationMessage="يرجى تعبئة هذا الحقل"
          />
        ) : (
          ""
        )}
        {state.InfoScientificFoundation?.sectorId !== 4&&state.MainResearcherInformation?.sU_NT_MRI_CountryOfResidenceId!==2? (
          <AllDropDownsAHSF
            fieldsName="NameOfTnstitution"
            show={true}
            yesNo={true}
            disabled={props.shouldDisableFields}
            dropdownType="normal"
            arrayOoptionList={state.DropDownSU_ST_MRI_FoundationName}
            KeyText={"foundationName"}
            KeyValue={"foundationNameId"}
            value={mainReserchInfo?.foundationNameId}
            onChange={(e) => {
              setMainReserchInfo({
                ...mainReserchInfo,
                foundationNameId: parseInt(e.target.value), // التحديث هنا
                otherFoundationName: null,
              });
            }}
            showValidationMessage={
              state.ValidateMainResearcherPageList
                ? state.ValidateMainResearcherPageList.includes(
                    "NameOfTnstitution"
                  )
                : false
            }
            //showValidationMessage={true}
            validationMessage="يرجى تعبئة هذا الحقل"
          />
        ) : (
          ""
        )}
        {state.InfoScientificFoundation?.foundationNameId == 12 ||
        state.InfoScientificFoundation?.foundationNameId == 29 ||
        state.InfoScientificFoundation?.foundationNameId == 39 ||
        state.InfoScientificFoundation?.foundationNameId == 40 ? (
          <TextAreaAHSF
            fieldsName="otherFoundationName"
            show={true}
            disabled={props.shouldDisableFields}
            defaultValue={mainReserchInfo?.otherFoundationName}
            onChange={(e) => {
              setMainReserchInfo({
                ...mainReserchInfo,
                otherFoundationName: e.target.value, // التحديث هنا
              });
            }}
            showValidationMessage={
              state.ValidateMainResearcherPageList
                ? state.ValidateMainResearcherPageList.includes(
                    "otherFoundationName"
                  )
                : false
            }
            validationMessage="يرجى تعبئة هذا الحقل"
          />
        ) : (
          ""
        )}
        <InputAHSF
          fieldsName="DepartmentCircle"
          show={true}
          disabled={props.shouldDisableFields}
          type={"text"}
          defaultValue={mainReserchInfo?.department}
          onChange={(e) => {
            setMainReserchInfo({
              ...mainReserchInfo,
              department: e.target.value, // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ValidateMainResearcherPageList
              ? state.ValidateMainResearcherPageList.includes(
                  "DepartmentCircle"
                )
              : false
          }
          validationMessage="حقل اجباري"
        />
        <InputAHSF
          fieldsName="College"
          show={true}
          disabled={props.shouldDisableFields}
          type={"text"}
          defaultValue={mainReserchInfo?.college}
          onChange={(e) => {
            setMainReserchInfo({
              ...mainReserchInfo,
              college: e.target.value, // التحديث هنا
            });
          }}
          //   showValidationMessage={
          //     state.ApplicationInformationValidationPage
          //       ? state.ApplicationInformationValidationPage.includes(
          //           "CellPhoneNumber"
          //         )
          //       : false
          //   }
          validationMessage="حقل اجباري"
        />
        <InputAHSF
          fieldsName="GeneralSpecialization"
          show={true}
          disabled={props.shouldDisableFields}
          type={"text"}
          defaultValue={mainReserchInfo?.generalMajor}
          onChange={(e) => {
            setMainReserchInfo({
              ...mainReserchInfo,
              generalMajor: e.target.value, // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ValidateMainResearcherPageList
              ? state.ValidateMainResearcherPageList.includes(
                  "GeneralSpecialization"
                )
              : false
          }
          validationMessage="حقل اجباري"
        />
        <InputAHSF
          fieldsName="Subspecialty"
          show={true}
          disabled={props.shouldDisableFields}
          type={"text"}
          defaultValue={mainReserchInfo?.subspecialty}
          onChange={(e) => {
            setMainReserchInfo({
              ...mainReserchInfo,
              subspecialty: e.target.value, // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ValidateMainResearcherPageList
              ? state.ValidateMainResearcherPageList.includes("Subspecialty")
              : false
          }
          validationMessage="حقل اجباري"
        />
        <AllDropDownsAHSF
          fieldsName="AcademicRank"
          show={true}
          yesNo={true}
          disabled={props.shouldDisableFields}
          dropdownType="normal"
          arrayOoptionList={state.DropDownSU_ST_MRI_AcademicRank}
          KeyText={"academicRankName"}
          KeyValue={"academicRankId"}
          value={mainReserchInfo?.academicRankId}
          onChange={(e) => {
            setMainReserchInfo({
              ...mainReserchInfo,
              academicRankId: parseInt(e.target.value), // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ValidateMainResearcherPageList
              ? state.ValidateMainResearcherPageList.includes("AcademicRank")
              : false
          }
          //showValidationMessage={true}
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <InputAHSF
          fieldsName="NationalDatabase"
          show={true}
          disabled={props.shouldDisableFields}
          type={"number"}
          defaultValue={mainReserchInfo?.natonalBaseResearcherNmberId}
          onChange={(e) => {
            setMainReserchInfo({
              ...mainReserchInfo,
              natonalBaseResearcherNmberId: e.target.value, // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ValidateMainResearcherPageList
              ? state.ValidateMainResearcherPageList.includes(
                  "NationalDatabase"
                )
              : false
          }
          validationMessage="حقل اجباري"
        />
        <InputAHSF
          fieldsName="BusinessPhoneNumber"
          show={true}
          disabled={props.shouldDisableFields}
          type={"number"}
          defaultValue={mainReserchInfo?.workPhoneNumber}
          onChange={(e) => {
            setMainReserchInfo({
              ...mainReserchInfo,
              workPhoneNumber: e.target.value, // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ValidateMainResearcherPageList
              ? state.ValidateMainResearcherPageList.includes(
                  "BusinessPhoneNumber"
                )
              : false
          }
          validationMessage="حقل اجباري"
        />
        <InputAHSF
          fieldsName="WorkEmail"
          show={true}
          disabled={props.shouldDisableFields}
          // type={"email"}
          defaultValue={mainReserchInfo?.email}
          onChange={(e) => {
            setMainReserchInfo({
              ...mainReserchInfo,
              email: e.target.value, // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ValidateMainResearcherPageList
              ? state.ValidateMainResearcherPageList.includes("WorkEmail") ||
                state.ValidateMainResearcherPageList.includes("EmailValidation")
              : false
          }
          validationMessage="حقل اجباري"
        />
      </div>
    </>
  ) : (
    ""
  );
};

export default InformationAboutScientificInstitution;
